import { Injectable } from '@angular/core';
import { DwContextDefinition, DwCustomContextBase, DwCustomContextDefinition, DwQuery, DwQueryHelper } from '@devwareapps/devware-cap';
import { AppMetaDataItemNames } from '../../../meta-data/app-meta-data.service';
import { UserTeamLookup } from '../models/user-team-lookup.model';

@DwCustomContextDefinition({
    keyName: 'TeamMonthlyNumbers',
    display: 'Team Monthly Numbers - Custom',
    item: 'TeamYearNumbers',
    parentItem :'UserTeamLookup',
    isGlobal: false,
})
@Injectable()
export class TeamMonthlyNumbersContextService extends DwCustomContextBase {

    setupContextDefinition(contextDef: DwContextDefinition) {
        
        contextDef.getCustomContextKey = (resolvedContext) => this.getCustomContextKey(resolvedContext);

        // Add custom functions to the context definition
        contextDef.buildQueryFunction = (resolvedContext) => this.buildQuery(resolvedContext);
    }

    buildQuery(resolvedContext: any): DwQuery {
        // Get the form data
        const userTeamLookup: UserTeamLookup = resolvedContext?.data;

        // If we're missing either field, don't run a query
        if (!userTeamLookup?.TeamId || !userTeamLookup?.FiscalYear) {
            return null;
        }

        // query user year numbers
        const query = new DwQuery('TeamYearNumbers');
        const qh = new DwQueryHelper();

        query.AddFilterAnd(qh.filters.Equal("EthosTeamId", userTeamLookup.TeamId));
        query.AddFilterAnd(qh.filters.Equal("FiscalYear", userTeamLookup.FiscalYear));

        return query;
    }

    getCustomContextKey(resolvedContext: any) {
        const userTeamLookup: UserTeamLookup = resolvedContext["data"];

          // If we're missing either field, don't run a query
          if (!userTeamLookup?.TeamId || !userTeamLookup?.FiscalYear) {
            return 'none';
        }

        return `${userTeamLookup.TeamId}_${userTeamLookup.FiscalYear}`;
    }

}